/**
 * Mock data for the acquisition "Ended Campaign" page — the shared
 * RunningCampaign template in its ended (historical) mode. Reuses the running
 * campaign's creative assets + top-websites (the historical record the owner
 * analyses), with the hero reframed as an ended campaign.
 * Temporary — remove when wired to an API (see docs/mock-data.md).
 */
import type { RunningCampaignData } from './types';
import { runningCampaignData } from './running-campaign';

const ART = '/assets/marketing/campaign-halloween.png';

export const endedCampaignData: RunningCampaignData = {
  header: { title: 'Ended Campaign Details' },
  hero: {
    image: ART,
    title: 'Euro 2024 Special acca insurance',
    subtitle: 'Acca insurance ran across the Euro 2024 tournament.',
    adSpend: { value: '$31,540', label: 'Ad Spend' },
    offering: { value: 'Acca Insurance', label: 'Offering' },
    duration: { value: 'June 14 - July 14', label: 'Duration' },
    // Default end timestamp; the dispatcher overrides it with the clicked
    // campaign's own "Ended on" date.
    endedOn: 'Jul 14, 23:00',
  },
  performance: {
    kpis: [
      {
        id: 'cpa',
        title: 'CPA',
        subtitle: 'Cost per acquired player',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$63', change: '-9%', changeType: 'decrease' },
      },
      {
        id: 'registrations',
        title: 'Registrations',
        subtitle: 'New players joining your website',
        today: { value: '0', change: '0%', changeType: 'decrease' },
        month: { value: '4,210', change: '+34%', changeType: 'increase' },
      },
      {
        id: 'ftds',
        title: 'FTDs',
        subtitle: 'Number of First Time Deposits',
        today: { value: '0', change: '0%', changeType: 'decrease' },
        month: { value: '1,980', change: '+28%', changeType: 'increase' },
      },
      {
        id: 'ftd-value',
        title: 'FTD Value',
        subtitle: 'Average First Time Deposits Value',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$182', change: '+11%', changeType: 'increase' },
      },
      {
        id: 'turnover',
        title: 'Turnover',
        subtitle: 'Money wagered by players',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$486,200', change: '+41%', changeType: 'increase' },
      },
      {
        id: 'ad-spend',
        title: 'Ad Spend',
        subtitle: 'Budget spent for this campaign',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$31,540', change: '+0%', changeType: 'increase' },
      },
    ],
  },
  assets: runningCampaignData.assets,
  topWebsites: runningCampaignData.topWebsites,
};

export default endedCampaignData;
